import { sideBarDefaultConfig } from '@/utils/grid-utils/ag-grid-config'
import {
  ColDef,
  ColGroupDef,
  GridReadyEvent,
  RowClassParams,
} from '@ag-grid-community/core'
import { AgGridReact } from '@ag-grid-community/react'
import React, { useEffect, useRef } from 'react'

export const ScenarioAnalysisOverviewTable: React.FC<{
  data: any[]
  columns: ColDef[] | ColGroupDef[]
  displayBenchmarkData?: boolean
  setGridReference: Function
}> = ({ data, columns, displayBenchmarkData, setGridReference }) => {
  const themeClassName = 'ag-theme-quartz'
  const gridRef = useRef<AgGridReact>(null)

  const getRowStyle = (params: RowClassParams) => {
    if (params.data.returnType === 'total_return_contrib') {
      return { fontWeight: '600', backgroundColor: 'inherit' }
    } else if (params.data.returnType.includes('horizon')) {
      return { fontWeight: '400', backgroundColor: '#E5E5E5' }
    }
    return { fontWeight: '400', backgroundColor: 'inherit' }
  }
  const onGridReady = (params: GridReadyEvent) => {
    params.api.sizeColumnsToFit()
    setGridReference(gridRef)
  }

  useEffect(() => {
    if (columns?.length <= 6) {
      gridRef.current?.api?.sizeColumnsToFit()
    } else if (columns?.length <= 9 && !displayBenchmarkData) {
      gridRef.current?.api?.sizeColumnsToFit()
    } else {
      gridRef.current?.api?.autoSizeAllColumns()
    }
  }, [columns, data])

  return (
    <div
      className={`${themeClassName} scenario-overview-table`}
      style={{ height: '100%' }}
    >
      <AgGridReact
        ref={gridRef}
        rowData={data}
        columnDefs={columns}
        getRowStyle={getRowStyle}
        onGridReady={onGridReady}
        sideBar={sideBarDefaultConfig}
      />
    </div>
  )
}
